import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { EnvelopeFill, Linkedin } from 'react-bootstrap-icons';
import TesterBudNavbar from '../subComponent/TesterBudNavBar';
import { Link } from 'react-router-dom';

import HeroImage from './icons/hero.jpeg';
const AboutPage = () => {
  return (
    <div className="home-page">
      <Container fluid className="hero-section bg-primary text-white py-5" style={{ position: 'relative', overflow: 'hidden' }}>
          <Row className="align-items-center justify-content-center">
            <Col md={6} className="text-center text-md-start">

              <h3 className="display-4 fw-bold mb-3">TesterBud – The Ultimate Automation Playground</h3>
              <p className="lead mb-2">
                TesterBud – The Ultimate Playground for Automation Testers! 🚀 Practice XPath, UI automation, and real-world testing challenges with interactive dummy sites.
              </p>
              <Button
                as={Link}
                to="/practice-page-selection"
                variant="warning"
                size="md"
                className="fw-bold text-dark border-0 shadow-sm"
                style={{
                  padding: "24px 36px",
                  borderRadius: "20px",
                  transition: "all 0.3s ease-in-out"
                }}
              >
                Get Started ➜
              </Button>

            </Col>
            <Col md={5} className="d-none d-md-block text-center">
              {/* Replace with your actual hero image component or import */}
              <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start' }}>
                <div
                  style={{
                    width: '60%', // Adjust the size of the circular area
                    height: '60%', // Ensure width and height are equal for a perfect circle
                    borderRadius: '70%', // This creates the circular shape
                    overflow: 'auto', // Clips the image to the circle
                    marginTop: '-4%',
                    marginRight: '10%',
                    marginBottom: '-4%',
                  }}
                >
                  <img src={HeroImage} alt="Automation Illustration" className="img-fluid" style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain', // Or 'cover' depending on desired behavior
                  }} />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <TesterBudNavbar />
    <Container className="py-5">
      
      
      <Row className="mb-5 text-center">
        <Col>
          <h1 className="display-4 fw-bold text-primary">About TesterBud</h1>
          <p className="lead text-secondary">
            Your premier destination for mastering automation and testing skills.
          </p>
        </Col>
      </Row>

      <Row className="mb-5">
        <Col md={10} className="mx-auto">
          <Card className="shadow p-4 border-0">
            <Card.Body>
              <Card.Text className="fs-5 text-muted" style={{ lineHeight: '1.8' }}>
                Welcome to <strong>TesterBud</strong>, your premier destination for mastering automation and testing skills.
                In today's fast-paced tech environment, proficiency in automation testing is not just an advantage—it's a necessity.
                We understand the challenges faced by aspiring QA professionals and have designed TesterBud to bridge the gap between
                theoretical knowledge and practical application.
                <br /><br />
                Our platform offers a comprehensive suite of resources, including a robust demo website for automation testing,
                enabling you to practice in real-world scenarios without the need for complex setups.
                Whether you're aiming to enhance your Selenium skills, master performance testing with JMeter, or explore Cypress automation,
                TesterBud provides the tools you need.
                <br /><br />
                New to the field? Our demo website for manual testing provides a gentle introduction to fundamental testing concepts.
                Advanced users can leverage our Cypress testing environments to explore cutting-edge automation frameworks.
                
                <br /><br />
                From simple login forms to complex e-commerce flows and flight bookings, our dummy websites simulate real-world scenarios
                so you can test and grow your skills safely. Sample websites are included for focused learning, such as
                sample login websites and sample eCommerce testing flows.
                <br /><br />
                TesterBud is more than a platform—it's a thriving community. We promote learning, collaboration, and open access to
                high-quality resources that are free for everyone. Whether you're practicing XPath, Selenium, Cypress, or just getting
                started, we’ve got you covered.
                <br /><br />
                Join us and elevate your QA journey with the best in hands-on testing practice. 🚀
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="text-center">
        <Col>
          <h4 className="text-primary mb-3">Connect with the Developer</h4>
          <p className="fs-5">
            <EnvelopeFill className="me-2 text-dark" />
            <a href="mailto:appdevelopers.ram@gmail.com" className="text-decoration-none text-dark">
              appdevelopers.ram@gmail.com
            </a>
          </p>
          <p className="fs-5">
            <Linkedin className="me-2 text-primary" />
            <a
              href="https://www.linkedin.com/in/ramendra-kumar-692409162/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-none text-primary"
            >
              linkedin.com/in/ramendra-kumar
            </a>
          </p>
        </Col>
      </Row>
    </Container>
    </div>
  );
};

export default AboutPage;